import { Select,Tag,Spin,Checkbox,Result,Button } from 'antd';
import React, { useEffect, useState } from 'react';
import { getUserDetail } from "./../../services";

import {
  ExperimentOutlined,
  HistoryOutlined,
  PlayCircleOutlined
} from "@ant-design/icons";
const OPTIONS = ['Apples', 'Nails', 'Bananas', 'Helicopters'];



const PdRunSelect = (props) => {
  const { user } = props;

  console.log(props);
  const [selectedItems, setSelectedItems] = useState([]);
  const [data, setData] = useState([]);
  const [allAcitivity, setallAcitivity] = useState([]);

  const [loading, setLoading] = useState(true);
  const [selectAll, setSelectAll] = useState(false);

  useEffect(() => {
    const fetchData = async () => {
      setSelectedItems([]);
      setLoading(true);
      const response = await getUserDetail(user);
      const { message } = response;
      setData(message);
      setLoading(false);

    };

    fetchData();
  }, [user]);

const filteredOptions = data.filter((o) => !selectedItems.includes(o.id));
  
const thisSelectChange = (value)=>{

  setSelectedItems(value);

  props.selectChange(value);
}

 const onCheckAllChange = (e) => {
    setSelectAll(e.target.checked);
    props.onSelectAllChild(e.target.checked);
    let ids = data.map(item=>item.run_id);
    ids = ids.join(",");
    setallAcitivity(ids);

  };

  const thisBtnClick = () =>{
    if(selectAll){

        props.thisSync(allAcitivity);  
    } else {
       props.thisSync(selectedItems);  
    }
    
  }

  return (
    <div className="pdSelectRunContainer" style={{padding:"50px 0 "}}>
     <h2>User Run List <Checkbox  onChange={onCheckAllChange} style={{position:"relative",left:"60px",fontSize:"18px"}} onc  >
        Select All Runs
      </Checkbox></h2> 
    <div style={{textAlign:"center"}}>


    { selectAll ? <Result
    status="success"
    title="Successfully Selected All Runs"
    subTitle={allAcitivity}
    extra={[
      <Button onClick={thisBtnClick} type="primary" key="console">
        Get Metrics &nbsp;<PlayCircleOutlined />
      </Button>,
  
    ]}
  /> : (loading ?  <Spin size="large" /> :  
      <Select

      mode="multiple"
      placement="topLeft"
      size="large"
      placeholder="Select runs"
      labelInValue="false"
      suffixIcon={<HistoryOutlined/>}
      showArrow="true"
      value={selectedItems}
      onChange={thisSelectChange}
      style={{
        width: '100%',
      }}
      options={filteredOptions.map((item) => ({
        element:item,
        value: item.id,
        label:<> <Tag color="green">{item.run_id}</Tag> {item.run_info?.place}  <Tag color="magenta">{item.run_info?.date}</Tag>  <Tag color="cyan"><ExperimentOutlined /> {item.ml_version}</Tag>   <Tag color="purple"><HistoryOutlined /> {item.no_of_intervals} </Tag></>
      }))}
    />)
     
    }


    <div style={{padding:"35px 0"}}> {( !selectAll && selectedItems.length > 0 ? <Button onClick={thisBtnClick} type="primary" key="console">
        Get Metrics &nbsp;<PlayCircleOutlined /> 
      </Button>: "")}
       </div>

   
    </div>
    </div>
  );
};

export default PdRunSelect;
